import { Column } from "native-base";

export default Column;